var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedln(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6428 32.6755V22.4434H17.2448V32.6755H20.6432H20.6428ZM18.9445 21.0466C20.1293 21.0466 20.8668 20.2609 20.8668 19.279C20.8446 18.2747 20.1293 17.5109 18.9671 17.5109C17.8041 17.5109 17.0446 18.2747 17.0446 19.2789C17.0446 20.2608 17.7818 21.0465 18.9223 21.0465H18.9443L18.9445 21.0466ZM22.5237 32.6755H25.9214V26.9621C25.9214 26.6567 25.9436 26.3504 26.0333 26.1323C26.2789 25.5211 26.8379 24.8883 27.7769 24.8883C29.0061 24.8883 29.4981 25.8266 29.4981 27.2022V32.6755H32.8958V26.8087C32.8958 23.666 31.2196 22.2035 28.9841 22.2035C27.1512 22.2035 26.3463 23.2288 25.899 23.9272H25.9217V22.4437H22.5238C22.5682 23.4036 22.5236 32.6759 22.5236 32.6759L22.5237 32.6755Z",
    fill: "#D0E8F4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#D0E8F4",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedln);
export default __webpack_public_path__ + "static/media/Linkedln.01f819fd0d7f1622d99b94b7029f61e6.svg";
export { ForwardRef as ReactComponent };